import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useApi } from '@backstage/core-plugin-api';
import { identityApiRef } from '@backstage/core-plugin-api';
import { Avatar, Box, Typography } from '@material-ui/core';
import { NotificationBell } from '@tranzact/backstage-plugin-notifications';

const useStyles = makeStyles(theme => ({
  statusBarWrapper: {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 'var(--sidebar-width)',
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: theme.zIndex.appBar - 1,
    height: '40px',
    width: '100%',
  },
  statusBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 3),
    height: '100%',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2),
  },
  divider: {
    height: '20px',
    margin: theme.spacing(0, 1),
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

export const StatusHeader = () => {
  const classes = useStyles();
  const identity = useApi(identityApiRef);
  const [userName, setUserName] = React.useState<string>('');
  const [base64Image, setBase64Image] = React.useState<string>('');

  React.useEffect(() => {
    const fetchIdentity = async () => {
      const { displayName, picture } = await identity.getProfileInfo();
      setUserName(displayName ?? '');
      setBase64Image(picture ?? '');
    };
    fetchIdentity();
  }, [identity]);

  const getInitials = (name: string) => {
    const words = name.trim().split(' ');

    if (words.length >= 2) {
      return `${words[0][0]}${words[1][0]}`.toUpperCase();
    } else if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }
    return 'AA';
  };

  return (
    <div className={classes.statusBarWrapper}>
      <Box className={classes.statusBar}>
        <Avatar
          className={classes.avatar}
          src={base64Image ? `${base64Image}` : undefined}
          alt="User avatar"
          style={{
            width: 30,
            height: 30,
          }}
        >
          {getInitials(userName)}
        </Avatar>
        &nbsp;&nbsp;
        {userName && (
          <Box className={classes.userInfo}>
            <Typography variant="body2" color="textSecondary">
              {userName}
            </Typography>
          </Box>
        )}
        <div className={classes.divider} />
        <NotificationBell />
      </Box>
    </div>
  );
};
